import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import ScrollTop from "../ScrollTop.js";
import SideBox from "../SideBox.js";
import Content from "../../components/ContentHeader.js";
import Route from "../../components/Route.js";

// css
import "../../css/News.css";
import "../../css/NewsPage.css";
import "../../css/Conference.css";

// img
import Cont04 from "../../assets/img/web_cont04.png";

function contents04() {
  return (
    <div className="webinar_wrap">
      <ScrollTop />

      <SideBox />

      {/* 페이지 타이틀명 설정 */}
      <Helmet>
        <title>레인보우브레인 | RPA+생성형AI 자동화 서비스 전문기업</title>
      </Helmet>
      <Content
        title="CONFERENCE"
        title1="콘텐츠를 통해 인사이트를 얻어보세요"
      />

      <Route route1="MEDIA" route2="CONFERENCE"></Route>

      <div className="contents_wrap content_bg">
        <div className="container">
          <div className="news_box">
            <div className="news_badge">
              <span>ONLINE</span>
            </div>

            <div className="news_content">
              <img src={Cont04} alt="이미지" />

              <div className="text_box">
                <p>
                  GPU 클러스터로 구성된 강력한 인프라에서 동작하는 LLM과는 달리
                  개인이 소유하는 단말에서 동작하는 sLLM이 실용화되는 한 해가 될
                  것으로 예상한다.
                  <br />
                  이미 구글, 삼성, 애플은 자사 스마트폰에 탑재하는 sLLM 개발
                  경쟁을 가속화하고 있으며, 민감한 개인 정보 규제 영역에 놓인
                  의료 기기 등에도 빠르게 적용될 것으로 보인다.
                </p>
              </div>
            </div>

            <div className="btn_webinar">공개예정</div>

            <div className="news_btn">
              <Link to="/media/conference">
                <button className="btn_prev">목록</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default contents04;
